export default __webpack_public_path__ + "static/media/stay-comfortable.8a73dc13.svg";